import { useState } from 'react';
import CardLayout from '../../../components/Layout/CardLayout';
import ReactDataTable from '../../../components/ReactDataTable/ReactDataTable';
import useFetch from '../../../hooks/useFetch';
import request from '../../../request/request';
import ModalLayout from '../../../components/Layout/ModalLayout';
import { formDataConverter, formDataConverterNew } from '../../../utils/necessaryFunctions';
import EditButton from '../../../components/Button/EditButton';
import DeleteButton from '../../../components/Button/DeleteButton';
import DeleteModal from '../../../components/Modal/DeleteModal';
import DestinationForm from '../../../components/Forms/Websites/Destination/DestinationForm';

const Destination = () => {
    const [modalOpen, setModalOpen] = useState('');
    const [selectedItem, setSelectedItem] = useState('');

    const { result, isLoading, setRefresh } = useFetch(() => request.getAll('destination'));

    const columns = [
        {
            name: 'Name',
            center: 'true',
            selector: (row) => row?.country_name,
        },
        {
            name: 'Image',
            width: '100px',
            cell: (row) => (
                <img
                    style={{ width: '100%' }}
                    src={`${process.env.REACT_APP_UPLOAD_URL}/website/${row?.country_img}`}
                    alt='side Img'
                />
            ),
        },
        {
            name: 'Description',
            wrap: true,
            center: 'true',
            selector: (row) => row?.description,
        },
        {
            name: 'Success Count',
            wrap: true,
            center: 'true',
            selector: (row) => row?.success_count,
        },
        {
            name: 'Country',
            center: 'true',
            selector: (row) => row?.country,
        },
        {
            name: 'Population',
            center: 'true',
            selector: (row) => row?.population,
        },
        {
            name: 'Capital',
            center: 'true',
            selector: (row) => row?.capital,
        },
        {
            name: 'Language',
            center: 'true',
            selector: (row) => row?.language,
        },
        {
            name: 'Currency',
            center: 'true',
            selector: (row) => row?.currency,
        },
        {
            name: 'Status',
            center: 'true',
            selector: (row) => (row?.status === 1 ? 'Active' : 'InActive'),
        },
        {
            name: 'Active',
            center: 'true',
            cell: (row) => (
                <div>
                    <EditButton
                        onClick={() => {
                            setModalOpen('update');
                            setSelectedItem(row);
                        }}
                    />
                    <DeleteButton
                        onClick={() => {
                            setModalOpen('delete');
                            setSelectedItem(row);
                        }}
                    />
                </div>
            ),
        },
    ];

    // create new function

    const createNewServiceHandler = (formValue) => {
        // const formData = formDataConverter(formValue);
        const formData = formDataConverterNew(formValue);
        console.log('FormData Destination', formData);

        request.create('destination', formData, () => {
            setModalOpen('');
            setRefresh((prev) => !prev);
        });
    };

    // update

    const updateServiceHandler = (formValue) => {
        // const formData = formDataConverter(formValue);
        const formData = formDataConverterNew(formValue);
        console.log('FormData Destination', formData);

        request.updateOne('destination', selectedItem?.id, formData, () => {
            setModalOpen('');
            setRefresh((prev) => !prev);
        });
    };

    // delete

    const deleteServiceHandler = () =>
        request.delete('destination', selectedItem?.id, () => {
            setModalOpen('');
            setRefresh((prev) => !prev);
        });

    return (
        <CardLayout
            title='Destination List'
            buttonTitle='Add new Destination'
            addButtonHandler={() => setModalOpen('create')}
        >
            <ReactDataTable data={result} columns={columns} pending={isLoading} />
            {/*= ============== create ===================== */}

            {modalOpen === 'create' && (
                <ModalLayout
                    isOpen={modalOpen === 'create'}
                    onClose={() => setModalOpen('')}
                    title='Create New Destination'
                    size='lg'
                >
                    <DestinationForm apiHandler={createNewServiceHandler} />
                </ModalLayout>
            )}

            {/* ======================= update ========================== */}

            {modalOpen === 'update' && (
                <ModalLayout
                    isOpen={modalOpen === 'update'}
                    onClose={() => setModalOpen('')}
                    title='Update New Destination'
                    size='lg'
                >
                    <DestinationForm apiHandler={updateServiceHandler} editData={selectedItem} />
                </ModalLayout>
            )}

            {/* ======================= delete ========================== */}

            {modalOpen === 'delete' && (
                <DeleteModal
                    isOpen={modalOpen === 'delete'}
                    onClose={() => setModalOpen('')}
                    handleDelete={deleteServiceHandler}
                />
            )}
        </CardLayout>
    );
};

export default Destination;
